/**
 * To generate the ./layout/spacing definitions, run ./layout/codegen.js
 */
import * as React from 'react'
import { css } from 'emotion'
import * as ec from '@emotion/core'
import styled from '@emotion/styled'
import { breakpoints as BREAKPOINTS_ } from './layout/config'
import * as breakpoints_ from './layout/breakpoints'
import * as spacing_ from './layout/spacing'
export * from './layout/motion'

/**
 *
 */

export type Breakpoint = keyof typeof breakpoints_
export type BreakpointDefinition = Array<[number, Breakpoint]>
export const BREAKPOINTS: BreakpointDefinition = BREAKPOINTS_ as any
export const breakpoints = breakpoints_

/**
 * Spacing
 *
 * Spaces define the distance beween components in a layout. They follow
 * a brief but powerful naming convention:
 *
 *                               TYPE       SIDES         SPACE
 *     <div class="plm"></div>   <p>adding  <l>eft        <m>edium
 *     <div class="mbs"></div>   <m>argin   <b>ottom      <s>mall
 *     <div class="pvs"></div>   <p>adding  <v>ertical    <s>mall
 *     <div class="mhl"></div>   <m>argin   <h>orizontal  <l>arge
 *
 * Types  - <p>adding, <m>argin
 * Sides  - <a>ll, <t>op, <r>ight, <b>ottom, <l>eft, <h>orizontal, <v>ertical
 * Spaces - As defined in the global $spaces variable, e.g. <n>one, <s>mall, <l>arge
 *
 * Origin: https://github.com/interactivethings/catalyst/blob/master/src/_spaces.scss
 * Refinement: http://tachyons.io/docs/layout/spacing/
 */

export const spacing = spacing_

export type Space = keyof typeof spacing

const space = (s: Space | Array<Space>): string => {
  const sArr: Array<Space> = typeof s === 'string' ? [s] : s
  return css(sArr.reduce((m, x: Space) => ({ ...m, ...spacing[x] }), {}))
}

export type SpaceProps = { [P in Space]?: boolean }

export const Space = (props: SpaceProps & { children: React.ReactNode }) => {
  const { children, ...spaceProps } = props
  const spaces: Array<Space> = Object.keys(spaceProps).filter((sp) => sp in spacing) as any
  return (
    <div
      className={css`
        ${space(spaces)}
      `}
    >
      {children}
    </div>
  )
}

/**
 *
 */

export const container = ec.css`
  margin: 0 auto;
  padding-left: 1rem;
  padding-right: 1rem;
  ${breakpoints.medium`
    max-width: calc(1364px);
  `};
`

export const Container = styled.div`
  ${container};
`
